/* eslint-disable no-unused-vars */
import React from "react";
import { Link } from "react-router-dom";
import {
  AccountBookFilled,
  VerticalAlignBottomOutlined,
  StepForwardOutlined,
  VerticalAlignMiddleOutlined,
  VerticalAlignTopOutlined,
  FastBackwardOutlined,
  FastForwardOutlined,
  ShrinkOutlined,
  ArrowsAltOutlined,
  DownOutlined,
  UpOutlined,
  LeftOutlined,
  RightOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
  CaretLeftOutlined,
  CaretRightOutlined,
  UpCircleOutlined,
  DownCircleOutlined,
  LeftCircleOutlined,
  RightCircleOutlined,
  DoubleRightOutlined,
  DoubleLeftOutlined,
  VerticalLeftOutlined,
  VerticalRightOutlined,
  VerticalAlignTopOutlin,
  VerticalAlignMiddleOut,
  VerticalAlignBottomOut,
  ForwardOutlined,
  BackwardOutlined,
  RollbackOutlined,
  EnterOutlined,
  RetweetOutlined,
  SwapOutlined,
  SwapLeftOutlined,
  SwapRightOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  PlayCircleOutlined,
  UpSquareOutlined,
  DownSquareOutlined,
  LeftSquareOutlined,
  RightSquareOutlined,
  LoginOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BorderBottomOutlined,
  BorderHorizontalOutlined,
  BorderInnerOutlined,
  BorderOuterOutlined,
  BorderLeftOutlined,
  BorderRightOutlined,
  BorderTopOutlined,
  BorderVerticleOutlined,
  PicCenterOutlined,
  PicLeftOutlined,
  PicRightOutlined,
  RadiusBottomleftOutlined,
  RadiusBottomrightOutlined,
  RadiusUpleftOutlined,
  RadiusUprightOutlined,
  FullscreenOutlined,
  FullscreenExitOutlined,
  QuestionCircleOutlined,
  PlusOutlined,
  PlusCircleOutlined,
  PauseOutlined,
  PauseCircleOutlined,
  MinusOutlined,
  MinusCircleOutlined,
  PlusSquareOutlined,
  MinusSquareOutlined,
  InfoOutlined,
  InfoCircleOutlined,
  ExclamationOutlined,
  ExclamationCircleOutlined,
  CloseOutlined,
  CloseCircleOutlined,
  CloseSquareOutlined,
  CheckOutlined,
  CheckCircleOutlined,
  CheckSquareOutlined,
  ClockCircleOutlined,
  WarningOutlined,
  IssuesCloseOutlined,
  StopOutlined,
  EditOutlined,
  FormOutlined,
  CopyOutlined,
  ScissorOutlined,
  DeleteOutlined,
  SnippetsOutlined,
  DiffOutlined,
  HighlightOutlined,
  AlignCenterOutlined,
  AlignLeftOutlined,
  AlignRightOutlined,
  BgColorsOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  StrikethroughOutlined,
  RedoOutlined,
  UndoOutlined,
  ZoomInOutlined,
  ZoomOutOutlined,
  FontColorsOutlined,
  FontSizeOutlined,
  LineHeightOutlined,
  DashOutlined,
  SmallDashOutlined,
  SortAscendingOutlined,
  SortDescendingOutlined,
  DragOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  RadiusSettingOutlined,
  ColumnWidthOutlined,
  ColumnHeightOutlined,
  AreaChartOutlined,
  PieChartOutlined,
  BarChartOutlined,
  DotChartOutlined,
  LineChartOutlined,
  RadarChartOutlined,
  HeatMapOutlined,
  FallOutlined,
  RiseOutlined,
  StockOutlined,
  BoxPlotOutlined,
  FundOutlined,
  SlidersOutlined,
  AndroidOutlined,
  AppleOutlined,
  WindowsOutlined,
  IeOutlined,
  ChromeOutlined,
  GithubOutlined,
  AliwangwangOutlined,
  DingdingOutlined,
  WeiboSquareOutlined,
  WeiboCircleOutlined,
  TaobaoCircleOutlined,
  Html5Outlined,
  WeiboOutlined,
  TwitterOutlined,
  WechatOutlined,
  YoutubeOutlined,
  AlipayCircleOutlined,
  TaobaoOutlined,
  SkypeOutlined,
  QqOutlined,
  MediumWorkmarkOutlined,
  GitlabOutlined,
  MediumOutlined,
  LinkedinOutlined,
  GooglePlusOutlined,
  DropboxOutlined,
  FacebookOutlined,
  CodepenOutlined,
  CodeSandboxOutlined,
  AmazonOutlined,
  GoogleOutlined,
  CodepenCircleOutlined,
  AlipayOutlined,
  AntDesignOutlined,
  AntCloudOutlined,
  AliyunOutlined,
  ZhihuOutlined,
  SlackOutlined,
  SlackSquareOutlined,
  BehanceOutlined,
  BehanceSquareOutlined,
  DribbbleOutlined,
  DribbbleSquareOutlined,
  InstagramOutlined,
  YuqueOutlined,
  AlibabaOutlined,
  YahooOutlined,
  RedditOutlined,
  SketchOutlined,
  WhatsAppOutlined,
  DingtalkOutlined,
} from "@ant-design/icons";
const ThemifyIcons = () => {
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}

          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Themify Icon</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Themify Icon</li>
                </ul>
              </div>
            </div>
          </div>

          {/* /Page Header */}
          <div className="row">
            {/* Chart */}
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="card-title">Themify Icon</div>
                </div>
                <div className="card-body">
                  <div className="icons-items">
                    <ul className="icons-list">
                      <li>
                        <AccountBookFilled />
                      </li>

                      <li>
                        <StepForwardOutlined />
                      </li>
                      <li>
                        <FastBackwardOutlined />
                      </li>
                      <li>
                        <FastForwardOutlined />
                      </li>
                      <li>
                        <ShrinkOutlined />
                      </li>
                      <li>
                        <ArrowsAltOutlined />
                      </li>
                      <li>
                        <DownOutlined />
                      </li>
                      <li>
                        <UpOutlined />
                      </li>
                      <li>
                        <LeftOutlined />
                      </li>
                      <li>
                        <RightOutlined />
                      </li>
                      <li>
                        <CaretUpOutlined />
                      </li>
                      <li>
                        <CaretDownOutlined />
                      </li>
                      <li>
                        <CaretLeftOutlined />
                      </li>
                      <li>
                        <CaretRightOutlined />
                      </li>
                      <li>
                        <UpCircleOutlined />
                      </li>
                      <li>
                        <DownCircleOutlined />
                      </li>
                      <li>
                        <LeftCircleOutlined />
                      </li>
                      <li>
                        <RightCircleOutlined />
                      </li>
                      <li>
                        <DoubleRightOutlined />
                      </li>
                      <li>
                        <DoubleLeftOutlined />
                      </li>
                      <li>
                        <VerticalLeftOutlined />
                      </li>
                      <li>
                        <VerticalRightOutlined />
                      </li>
                      <li>
                        <VerticalAlignTopOutlined />
                      </li>
                      <li>
                        <VerticalAlignMiddleOutlined />
                      </li>
                      <li>
                        <VerticalAlignBottomOutlined />
                      </li>
                      <li>
                        <ForwardOutlined />
                      </li>
                      <li>
                        <BackwardOutlined />
                      </li>
                      <li>
                        <RollbackOutlined />
                      </li>
                      <li>
                        <EnterOutlined />
                      </li>
                      <li>
                        <RetweetOutlined />
                      </li>
                      <li>
                        <SwapOutlined />
                      </li>
                      <li>
                        <SwapLeftOutlined />
                      </li>
                      <li>
                        <SwapRightOutlined />
                      </li>
                      <li>
                        <ArrowUpOutlined />
                      </li>
                      <li>
                        <ArrowDownOutlined />
                      </li>
                      <li>
                        <ArrowLeftOutlined />
                      </li>
                      <li>
                        <ArrowRightOutlined />
                      </li>
                      <li>
                        <PlayCircleOutlined />
                      </li>
                      <li>
                        <UpSquareOutlined />
                      </li>
                      <li>
                        <DownSquareOutlined />
                      </li>
                      <li>
                        <LeftSquareOutlined />
                      </li>
                      <li>
                        <RightSquareOutlined />
                      </li>
                      <li>
                        <LoginOutlined />
                      </li>
                      <li>
                        <LogoutOutlined />
                      </li>
                      <li>
                        <MenuFoldOutlined />
                      </li>
                      <li>
                        <MenuUnfoldOutlined />
                      </li>
                      <li>
                        <BorderBottomOutlined />
                      </li>
                      <li>
                        <BorderHorizontalOutlined />
                      </li>
                      <li>
                        <BorderInnerOutlined />
                      </li>
                      <li>
                        <BorderOuterOutlined />
                      </li>
                      <li>
                        <BorderLeftOutlined />
                      </li>
                      <li>
                        <BorderRightOutlined />
                      </li>
                      <li>
                        <BorderTopOutlined />
                      </li>
                      <li>
                        <BorderVerticleOutlined />
                      </li>
                      <li>
                        <PicCenterOutlined />
                      </li>
                      <li>
                        <PicLeftOutlined />
                      </li>
                      <li>
                        <PicRightOutlined />
                      </li>
                      <li>
                        <RadiusBottomleftOutlined />
                      </li>
                      <li>
                        <RadiusBottomrightOutlined />
                      </li>
                      <li>
                        <RadiusUpleftOutlined />
                      </li>
                      <li>
                        <RadiusUprightOutlined />
                      </li>
                      <li>
                        <FullscreenOutlined />
                      </li>
                      <li>
                        <FullscreenExitOutlined />
                      </li>

                      <li>
                        <QuestionCircleOutlined />
                      </li>
                      <li>
                        <PlusOutlined />
                      </li>
                      <li>
                        <PlusCircleOutlined />
                      </li>
                      <li>
                        <PauseOutlined />
                      </li>
                      <li>
                        <PauseCircleOutlined />
                      </li>
                      <li>
                        <MinusOutlined />
                      </li>
                      <li>
                        <MinusCircleOutlined />
                      </li>
                      <li>
                        <PlusSquareOutlined />
                      </li>
                      <li>
                        <MinusSquareOutlined />
                      </li>
                      <li>
                        <InfoOutlined />
                      </li>
                      <li>
                        <InfoCircleOutlined />
                      </li>
                      <li>
                        <ExclamationOutlined />
                      </li>
                      <li>
                        <ExclamationCircleOutlined />
                      </li>
                      <li>
                        <CloseOutlined />
                      </li>
                      <li>
                        <CloseCircleOutlined />
                      </li>
                      <li>
                        <CloseSquareOutlined />
                      </li>
                      <li>
                        <CheckOutlined />
                      </li>
                      <li>
                        <CheckCircleOutlined />
                      </li>
                      <li>
                        <CheckSquareOutlined />
                      </li>
                      <li>
                        <ClockCircleOutlined />
                      </li>
                      <li>
                        <WarningOutlined />
                      </li>
                      <li>
                        <IssuesCloseOutlined />
                      </li>
                      <li>
                        <StopOutlined />
                      </li>
                      <li>
                        <EditOutlined />
                      </li>
                      <li>
                        <FormOutlined />
                      </li>
                      <li>
                        <CopyOutlined />
                      </li>
                      <li>
                        <ScissorOutlined />
                      </li>
                      <li>
                        <DeleteOutlined />
                      </li>
                      <li>
                        <SnippetsOutlined />
                      </li>
                      <li>
                        <DiffOutlined />
                      </li>
                      <li>
                        <HighlightOutlined />
                      </li>
                      <li>
                        <AlignCenterOutlined />
                      </li>
                      <li>
                        <AlignLeftOutlined />
                      </li>
                      <li>
                        <AlignRightOutlined />
                      </li>
                      <li>
                        <BgColorsOutlined />
                      </li>
                      <li>
                        <BoldOutlined />
                      </li>
                      <li>
                        <ItalicOutlined />
                      </li>
                      <li>
                        <UnderlineOutlined />
                      </li>
                      <li>
                        <StrikethroughOutlined />
                      </li>
                      <li>
                        <RedoOutlined />
                      </li>
                      <li>
                        <UndoOutlined />
                      </li>
                      <li>
                        <ZoomInOutlined />
                      </li>
                      <li>
                        <ZoomOutOutlined />
                      </li>
                      <li>
                        <FontColorsOutlined />
                      </li>
                      <li>
                        <FontSizeOutlined />
                      </li>
                      <li>
                        <LineHeightOutlined />
                      </li>
                      <li>
                        <DashOutlined />
                      </li>
                      <li>
                        <SmallDashOutlined />
                      </li>
                      <li>
                        <SortAscendingOutlined />
                      </li>
                      <li>
                        <SortDescendingOutlined />
                      </li>
                      <li>
                        <DragOutlined />
                      </li>
                      <li>
                        <OrderedListOutlined />
                      </li>
                      <li>
                        <UnorderedListOutlined />
                      </li>
                      <li>
                        <RadiusSettingOutlined />
                      </li>
                      <li>
                        <ColumnWidthOutlined />
                      </li>
                      <li>
                        <ColumnHeightOutlined />
                      </li>
                      <li>
                        <AreaChartOutlined />
                      </li>
                      <li>
                        <PieChartOutlined />
                      </li>
                      <li>
                        <BarChartOutlined />
                      </li>
                      <li>
                        <DotChartOutlined />
                      </li>
                      <li>
                        <LineChartOutlined />
                      </li>
                      <li>
                        <RadarChartOutlined />
                      </li>
                      <li>
                        <HeatMapOutlined />
                      </li>
                      <li>
                        <FallOutlined />
                      </li>
                      <li>
                        <RiseOutlined />
                      </li>
                      <li>
                        <StockOutlined />
                      </li>
                      <li>
                        <BoxPlotOutlined />
                      </li>
                      <li>
                        <FundOutlined />
                      </li>
                      <li>
                        <SlidersOutlined />
                      </li>
                      <li>
                        <AndroidOutlined />
                      </li>
                      <li>
                        <AppleOutlined />
                      </li>
                      <li>
                        <WindowsOutlined />
                      </li>
                      <li>
                        <IeOutlined />
                      </li>
                      <li>
                        <ChromeOutlined />
                      </li>
                      <li>
                        <GithubOutlined />
                      </li>
                      <li>
                        <AliwangwangOutlined />
                      </li>
                      <li>
                        <DingdingOutlined />
                      </li>
                      <li>
                        <WeiboSquareOutlined />
                      </li>
                      <li>
                        <WeiboCircleOutlined />
                      </li>
                      <li>
                        <TaobaoCircleOutlined />
                      </li>
                      <li>
                        <Html5Outlined />
                      </li>
                      <li>
                        <WeiboOutlined />
                      </li>
                      <li>
                        <TwitterOutlined />
                      </li>
                      <li>
                        <WechatOutlined />
                      </li>
                      <li>
                        <YoutubeOutlined />
                      </li>
                      <li>
                        <AlipayCircleOutlined />
                      </li>
                      <li>
                        <TaobaoOutlined />
                      </li>
                      <li>
                        <SkypeOutlined />
                      </li>
                      <li>
                        <QqOutlined />
                      </li>
                      <li>
                        <MediumWorkmarkOutlined />
                      </li>
                      <li>
                        <GitlabOutlined />
                      </li>
                      <li>
                        <MediumOutlined />
                      </li>
                      <li>
                        <LinkedinOutlined />
                      </li>
                      <li>
                        <GooglePlusOutlined />
                      </li>
                      <li>
                        <DropboxOutlined />
                      </li>
                      <li>
                        <FacebookOutlined />
                      </li>
                      <li>
                        <CodepenOutlined />
                      </li>
                      <li>
                        <CodeSandboxOutlined />
                      </li>
                      <li>
                        <AmazonOutlined />
                      </li>
                      <li>
                        <GoogleOutlined />
                      </li>
                      <li>
                        <CodepenCircleOutlined />
                      </li>
                      <li>
                        <AlipayOutlined />
                      </li>
                      <li>
                        <AntDesignOutlined />
                      </li>
                      <li>
                        <AntCloudOutlined />
                      </li>
                      <li>
                        <AliyunOutlined />
                      </li>
                      <li>
                        <ZhihuOutlined />
                      </li>
                      <li>
                        <SlackOutlined />
                      </li>
                      <li>
                        <SlackSquareOutlined />
                      </li>
                      <li>
                        <BehanceOutlined />
                      </li>
                      <li>
                        <BehanceSquareOutlined />
                      </li>
                      <li>
                        <DribbbleOutlined />
                      </li>
                      <li>
                        <DribbbleSquareOutlined />
                      </li>
                      <li>
                        <InstagramOutlined />
                      </li>
                      <li>
                        <YuqueOutlined />
                      </li>
                      <li>
                        <AlibabaOutlined />
                      </li>
                      <li>
                        <YahooOutlined />
                      </li>
                      <li>
                        <RedditOutlined />
                      </li>
                      <li>
                        <SketchOutlined />
                      </li>
                      <li>
                        <WhatsAppOutlined />
                      </li>
                      <li>
                        <DingtalkOutlined />
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* /Chart */}
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};
export default ThemifyIcons;
